import React, { useState } from 'react';
import { ADMIN_API_URL } from "../../constants";
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { setCredentials } from '../../store/authSlice';

const LoginPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        username: "",
        password: "",
        role: "admin",
    });
    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent the default form submission
        const controller = new AbortController();
        const messageDiv = document.getElementById("frm-error");
        const timeout = setTimeout(() => controller.abort(), 6000);
        try {
            const response = await fetch(""+ADMIN_API_URL+"sign-in", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });
            clearTimeout(timeout);
            if(response.status !== 200){
                const v_result = await response.json();
                throw new Error(v_result.message);
            }

            // Get the response data (new format)
            const data = await response.json();
            const token = data.data.token;
            const user = data.data.user;

            // Store in Redux
            console.log('Dispatching setCredentials with:', { user, token });
            dispatch(setCredentials({ user, token }));
            // Persist token and user info in sessionStorage for reloads
            sessionStorage.setItem("authToken", token);
            sessionStorage.setItem("userInfo", JSON.stringify(user));

            // Debug: Check Redux state after dispatch
            setTimeout(() => {
                if (user?.userType === 'anchor') {
                    console.log('Anchor login successful, navigating to /anchor/dashboard');
                    navigate("/anchor/dashboard");
                } else {
                console.log('Login successful, navigating to /leads');
                navigate("/leads");
                }
            }, 100);
        } catch (error) {
            console.error("Error submitting form:", error);
            messageDiv.style.color = "red";
            messageDiv.textContent = error.message;
            messageDiv.style.display = "block";
        }
        setTimeout(() => messageDiv.style.display = "none", 3000);
    };
    return (
        <>
            <div className="color-line"></div>

            <div className="login-container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="text-center m-b-md">
                            <h3>PLEASE LOGIN TO APP</h3>
                            <small>This is the best app ever!</small>
                        </div>
                        <div className="hpanel">
                            <div className="panel-body">
                                <form id="loginForm" onSubmit={handleSubmit}>
                                    <div className="form-group" id='frm-error'></div>
                                    <div className="form-group">
                                        <input type="text" placeholder="Enter your username" title="Please enter your username" required="" value={formData.username}
            onChange={handleChange} name="username" id="username" className="form-control" />
                                        <span className="help-block small">Enter your username</span>
                                    </div>
                                    <div className="form-group">
                                        <input type="password" title="Please enter your password" placeholder="******" required="" value={formData.password}
            onChange={handleChange} name="password" id="password" className="form-control" />
                                        <span className="help-block small">Enter your password</span>
                                    </div>
                                    <input type="hidden" name="role" value={formData.role} />
                                    <button className="btn btn-success btn-block">Login</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 text-center">
                        <strong>GROWBIZH</strong> - Admin WebApp <br/> 2025 Copyright
                    </div>
                </div>
            </div>
        </>
    );
}

export default LoginPage;